// extracted by mini-css-extract-plugin
export default {"label":"BirthDaySelect_label__R9szu","labelRequire":"BirthDaySelect_labelRequire__zc5Ko"};